module.exports = __webpack_public_path__ + "static/media/Negative.8dbf5c23.svg";